import * as React from "react";
import { Modal, Button } from "antd";
import { TReportingPeriodPresentationModel } from "../../../presenter/reporting/model/ReportingPeriodPresentationModel";
import { TRandomSelectionPresentationModel } from "../../../presenter/reporting/ReportingPeriodPresenter";

export interface State {}

export interface Props {
  modalVisible: boolean;
  translate: any;
  onChange: (
    value: boolean,
    record?: TReportingPeriodPresentationModel
  ) => void;
  Form: any;
  onCreate: any;
  percentage?: number;
  data?: TRandomSelectionPresentationModel;
  loading?: boolean;
}

export default class RandomSelectionDialog extends React.Component<
  Props,
  State
> {
  private formSubmitHandler: any;
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.registerFormSubmitEventHandler = this.registerFormSubmitEventHandler.bind(
      this
    );
  }

  registerFormSubmitEventHandler(registrationHandler) {
    this.formSubmitHandler = registrationHandler;
  }

  private onSubmit(e) {
    const { onCreate } = this.props;
    if (this.formSubmitHandler) {
      let newData = this.formSubmitHandler(e);
      if (newData) {
        onCreate(newData);
      }
    }
  }

  render() {
    const {
      translate,
      modalVisible,
      onChange,
      Form,
      percentage,
      data,
      loading
    } = this.props;

    return (
      <div>
        <Modal
          title={translate("random_selection.dialog.title")}
          visible={modalVisible}
          onCancel={() => onChange(false)}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={() => onChange(false)}>
              {translate("modal_functions.assign_modal.cancel")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={this.onSubmit}
            >
              {translate("random_selection.submit.title")}
            </Button>
          ]}
        >
          <Form
            translate={translate}
            registerFormSubmitEventHandler={this.registerFormSubmitEventHandler}
            onCancel={() => onChange(false)}
            percentage={percentage}
            data={data}
          />
        </Modal>
      </div>
    );
  }
}
